import { id } from 'date-fns/locale';
import { makeAutoObservable, runInAction } from 'mobx';
import { toast } from 'react-toastify';
import agent from '../api/agent';
import { CCTCuenta } from '../models/CCTCuenta';
import { CCTOperacion, CCTOperacionesFormValues } from '../models/CCTOperacion';
import { DPI, DPIFormValues } from '../models/dpi';
import { getTranxTipoCta } from '../models/getTranxTipoCta';
import { store, useStore } from './store';

export default class CCTOperacionStore {
    CCTOperacionRegistry = new Map<any, CCTOperacion>();
    TransaccionRegistry = new Map<any, getTranxTipoCta>();
    DPIRegistry = new Map<any, DPI>();
    

    selectedCCTOperacion: CCTOperacion | undefined = undefined;
    selectedTransaccion: getTranxTipoCta | undefined = undefined;
    selectedDPI: DPI | undefined = undefined;

    editMode = false;
    loading = false;
    loadingInitial = false;
    saldo_actual_total:string = ""
    condicion = false

    CCTCuentaRegistry = new Map<any, CCTCuenta>();
    selectedCCTCuenta: CCTCuenta | undefined = undefined;
  static dpiByCodigo: any;
  
    constructor() {
        makeAutoObservable(this)
    }

    get CCTOperacionByCodigo() {
        return Array.from(this.CCTOperacionRegistry.values());
    }

    get dpiByCodigo() {
        return Array.from(this.DPIRegistry.values());
    }

    get TransaccionByCodigo() {
        return Array.from(this.TransaccionRegistry.values());
    }

    get groupedCCTMovimientos() {
        return this.CCTOperacionRegistry
    }

    personaDPI = async (usuario: any): Promise<DPI[]> => {
        try {
            this.CCTOperacionRegistry.clear();
            this.DPIRegistry.clear();
    
            const dpi: DPI[] = await agent.SGPersonas.persona(usuario);
            
            dpi.forEach(element => {
                this.setDPI(element);
            });
    
            this.setLoadingInitial(false);
            this.kk(this.dpiByCodigo);
            this.nombre(this.dpiByCodigo);
    
            return dpi; // 🔥 Ahora devuelve los datos correctamente
        } catch (error) {
            this.setLoadingInitial(false);
            return []; // Devuelve un array vacío en caso de error
        }
    };
    

    
    kk = (cu:any) => {
        cu.map((persona:any) => {
            this.loadCCTCuentaDPI(persona.id)
        })
    }

    nombre = (c:any) => {
        return c
    }

    private setCCTMovimiento = (data: CCTOperacion) => {
        this.CCTOperacionRegistry.set(data.cuenta, data);
    }

    private setDPI = (dpiNombre: DPI) => {
        this.DPIRegistry.set(dpiNombre.id, dpiNombre);
    }
    
    private setTransaccion = (transaccion: getTranxTipoCta) => {
        this.TransaccionRegistry.set(transaccion.id, transaccion);
    }

    private getCCTMovimiento = (idCliente: any) => {
        return this.CCTOperacionRegistry.get(idCliente);
    }

    setLoadingInitial = (state: boolean) => {
        this.loadingInitial = state;
    }

    getTransacciones = async (cuenta:string) => {
        try {
            this.TransaccionRegistry.clear()
            const trans:getTranxTipoCta[] = await agent.CCTTiposTransXTipoCtas.transmanual(cuenta)
            this.condicion = true
            trans.forEach(element => {
                this.setTransaccion(element);
            })
            this.setLoadingInitial(false);
            //console.log("Detalle de cuentas", getTranxTipoCta)
            return getTranxTipoCta;
            
        }catch (error){

        }
    }

    createCCTOperacion = async (CCTOperacion: CCTOperacionesFormValues) => {
        try {
            await agent.CCTOperaciones.create(CCTOperacion);
            runInAction(() => {
                this.selectedCCTOperacion = CCTOperacion;
                this.loading = false;
            })
        } catch (error) {
            runInAction(() => {
                this.loading = false;
            })
        }
    }

    loadCCTCuentaDPI = async (idCliente: string) => {
        try {
            this.CCTCuentaRegistry.clear()
            const CCTCuentas: CCTCuenta[] =  await agent.CCTCuentas.details(idCliente);
            this.condicion = true
            CCTCuentas.forEach(element => {
                this.setCCTCuenta(element);
            })
        } catch (error) {
        }
    }

    private setCCTCuenta = (data: CCTCuenta) => {  
        this.CCTCuentaRegistry.set(data.id, data);
    }

    get CCTCuentaByCodigo() {
        return Array.from(this.CCTCuentaRegistry.values());
    }

    get inputPersona(){
        if(this.dpiByCodigo.length <= 0){
            return true
        }else{
            return false
        }
        
    }

    
}
